import { useSignupModal } from "@/features/signup/SignupModal";
import { useMaestriaContent } from "@/shared/i18n/LocaleContext";
import { ButtonLink } from "@/shared/components/ButtonLink/ButtonLink";
import styles from "./StickyCta.module.css";

/** CTA fixo no rodapé do mobile: acompanha a rolagem da página inteira. */
export function StickyCta() {
  const openSignup = useSignupModal();
  const { hero } = useMaestriaContent();

  return (
    <div className={styles.bar}>
      <ButtonLink onClick={openSignup} className={styles.button}>
        {hero.cta.label}
      </ButtonLink>
    </div>
  );
}
